import { ResponseError } from '../../errors';
import { IJsonQuery } from '../../json_query';
import { fetchGetQuickLinks, TGetQuickLinksResponse } from '../../repositories/monolith-python/v1/get-quick-links';
import { IApplicationContext } from '../../types/applicationContext';
import { IQuickLinks } from '../../types/quickLinks';

interface IFetchQuickLinksParameters {
  subdomain: string;
  jsonQuery: IJsonQuery;
}

async function fetchQuickLinks(
  { httpApi }: IApplicationContext,
  { subdomain, jsonQuery }: IFetchQuickLinksParameters,
): Promise<IQuickLinks | null> {
  const quickLinksData: TGetQuickLinksResponse = await fetchGetQuickLinks({
    httpApi,
    parameters: { jsonQuery },
    config: {
      subdomain,
    },
  });

  if (quickLinksData.statusCode !== 200) {
    throw new ResponseError({
      domain: 'fetchQuickLinks',
      message: quickLinksData.response.message,
      details: {
        error: quickLinksData.response.errors,
      },
    });
  }

  return quickLinksData.response.data.quickLinks || null;
}

export async function fetchQuickLinksSafe(
  context: IApplicationContext,
  parameters: IFetchQuickLinksParameters,
): Promise<IQuickLinks | null> {
  try {
    return await fetchQuickLinks(context, parameters);
  } catch (ex) {
    const { logger } = context;

    logger.warning(ex, { degradation: 'Быстрые ссылки' });

    return null;
  }
}
